module.exports = [require("./Acre.js"), require("./DeNoronha.js"), require("./East.js"), require("./West.js")];